// import Vue from 'vue'
import axios from 'axios'
// import { config } from 'shelljs'
/**
 * 环境切换
 */
let apiUrl = ''
let HOST = process.env.HOST
// 打包后用nginx反代，避免跨域问题，无需指定访问地址
if (HOST === 'prod') {
  apiUrl = '/website-api'
}
if (HOST === 'test') {
  apiUrl = 'http://192.168.132.171:30010/service-info-provider'
}
axios.defaults.baseURL = apiUrl

const http = axios.create({
  baseURL: process.env.BASE_API // api的base_url
  // timeout: 5000 // 请求超时时间
})

// 请求拦截
axios.interceptors.request.use()
export default http



// WEBPACK FOOTER //
// ./src/plugins/axios.js